import {getAxiosInstance, requestConfig} from "../../http-common";
import { CreateNewCondition } from "../../models/migrationrules/CreateNewCondition";
import { UpdateCondition } from "../../models/migrationrules/UpdateCondition";

const RESOURCE_NAME = "BatchProcessing";

const getAll = (activeOnly: boolean) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/GetQueueOnInit?activeOnly=${activeOnly}`, requestConfig());
};

const getAllStepTemplates = (model : any) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/GetAllStepTemplates?entity=${model.entity}&groupcode=${model.groupcode}`, requestConfig());
};
  
const createTask = (model : any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/CreateTask`, model, requestConfig());
};

const getQueue = () => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/GetQueue`, requestConfig());
};

const getStepDetailsById = (model : any) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/GetStepDetailsById?stepId=${model.stepId}&entity=${model.entity}&groupcode=${model.groupcode}`, requestConfig());
};

const updateStepParameters = (model : any) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/UpdateStepParameters/${model.stepId}`, model, requestConfig());
};

const executeStep = (model : any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/ExecuteStep`, model, requestConfig());
};

const cancelStep = (model : any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/CancelStep`, model, requestConfig());
};

const createStep = (model : any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/CreateStep`, model, requestConfig());
};

const executeTask = (model : any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/ExecuteTask/${model}`, model, requestConfig());
};

const cancelTask = (model : any) => {
  const http = getAxiosInstance();
  return http.post(`${RESOURCE_NAME}/CancelTask/${model}`, model, requestConfig());
};

const updateTask = (taskId: number, model : any) => {
  const http = getAxiosInstance();
  return http.put(`${RESOURCE_NAME}/UpdateTask/${taskId}`, model, requestConfig());
};

const deleteTask = (taskId: number) => {
  const http = getAxiosInstance();
  return http.delete(`${RESOURCE_NAME}/DeleteTask/${taskId}`, requestConfig());
};

const deleteTasks = (taskIds: number[]) => {
  const http = getAxiosInstance();
  const model = {
    taskIds: taskIds,
  }

  return http.post(`${RESOURCE_NAME}/DeleteTasks`, model, requestConfig());
};

const getLogs = (taskId : any) => {
  const http = getAxiosInstance();
  return http.get(`${RESOURCE_NAME}/getLogs?taskId=${taskId}`, requestConfig());
};


const BatchProcessingService = {
  getAll,
  getAllStepTemplates,
  createTask,
  getQueue,
  getStepDetailsById,
  updateStepParameters,
  executeStep,
  cancelStep,
  createStep,
  executeTask,
  cancelTask,
  updateTask,
  getLogs,
  deleteTask,
  deleteTasks
};
export default BatchProcessingService;
